import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {Link} from "../../link/link";
import {ListItemViewModel} from "../../../../infrastructure/models/list-item.view-model";

export class TabButtonComponentProps extends BaseProps {
  className: String;
  tab: ListItemViewModel;
  onClick: Function = () => true;
  active: Boolean;
  noFollow: Boolean;
  linkModel: BaseLinkModel;
  routeProps: Object;
}

export const TabLinkButton = ({linkModel, noFollow, className, onClick, tab, routeProps, children}: TabButtonComponentProps) => {
  const linkProps = {
    model: linkModel,
    noFollow: noFollow,
    className: className,
    onClick: (e) => onClick(e, tab),
    routeProps: routeProps,
    id: tab?.elementId
  }

  return (
    <Link {...linkProps}>
      {children}
    </Link>
  )
};
